import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Outcome } from "./ConfirmStep";
import { primaryButton } from "./styles";

type Props = {
    outcome: Outcome;
    formatDate: (iso: string) => string;
};

const ResultStep: React.FC<Props> = ({ outcome, formatDate }) => {
    const { t } = useTranslation();
    const requested = outcome.kind === "requested";

    return (
        <div className="space-y-5 text-center">
            <div
                className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${requested ? "bg-red-50 text-red-600" : "bg-[#00B9EC]/10 text-[#00B9EC]"}`}
            >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                </svg>
            </div>
            <h2 className="text-xl font-bold text-gray-900">
                {t(requested ? "delete_account.done_title" : "delete_account.cancelled_title")}
            </h2>
            <p className="text-gray-600">
                {requested
                    ? t("delete_account.done_body", { date: formatDate(outcome.scheduledFor) })
                    : t("delete_account.cancelled_body")}
            </p>
            <Link to="/" className={primaryButton}>
                {t("delete_account.back_home")}
            </Link>
        </div>
    );
};

export default ResultStep;
